const Config = {
  'firebaseRootFolderName': 'codus',
  'jwtStorageKey': 'jwt-codus-a8dsfj2aef',
  'SaltBefore': 's89a',
  'SaltAfter': '129a'
}

export default Config
